// removed by extract-text-webpack-plugin
module.exports = {"cam":"cam__cam___3UUhc"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Components/Cam/cam.scss
// module id = 118
// module chunks = 0